export default {
    title: 'Service Queue',
    open_services: 'Open Services',
    realized_services: 'Completed Services',
    position: 'º in the queue',
    realize: {
        success: 'Service successfully completed.',
        error: 'An error occurred while trying to save the service completion.'
    },
    filter: {
        title: 'Filter',
        company: 'Company',
        unit_care: 'Care Unit',
        sector: 'Sector',
        filter_button: 'Filter',
        clear_button: 'Clear Filters'
    },
    caption: {
        title: 'Legend',
        service: 'Service Legend',
        service_queue: 'Service Queue',
        service_waiting: 'Waiting for Service',
        realized_service: 'Service Completed',
        report_not_send: 'The result has not been sent yet',
        report_sended: 'The result has been sent',
    }
}
